import React from 'react';

export const faq = (withTemplate) => {
  if (withTemplate) {
    return [
      {
        title: 'How does it work?',
        body: <>
          <div>
            <b>WTL Studio uses Google and social networks to learn about your business.</b> We use
            this information to create an up-to-date website for your company.
          </div>
          <br/>
          <i>
            All information we find belongs to their respective owners. WTL Studio does not use this information without
            consent in any way.
          </i>
        </>
      },
      {
        title: 'Can I change parts of the website?',
        body: <>
          <div>
            <b>Yes! In fact, you can change any and all of it.</b> After you create an account, you will gain access to
            WTL Studio website builder which allows you to change nearly every detail of the website. 
          </div>
        </>
      },
      {
        title: 'When will the website be avilable?',
        body: <>
          <div>
            After you create an account, you will receive an activation email from us. Your website becomes available
            within <b>5 minutes</b> after the account is activated.
          </div>
        </>
      },
      {
        title: 'Can I use different website address?',
        body: <>
          <div>
            <b>company</b>.wtlstudio.com is a default address for any WTL Studio website.
          </div>
          <div>
            You can use your own address, like <b>company.com</b>. You will receive the details after activating your account.
          </div>
        </>
      },
      {
        title: 'Images used in the website do not belong to me.',
        body: <>
          <div>
            WTL Studio uses company images found in Google and social networks. We do not claim or grant copyrights
            for these images.
          </div>
          <br/>
          <i>
            If you believe any of the images on the generated website infringe third-party copyrights, you are responsible for changing
            them before publishing the website.
          </i>
          <div>
            Some of the images may also come from the photography service <a href="https://pexels.com" rel="nofollow" target="_blank">Pexels.com</a>.
          </div>
        </>
      },
      {
        title: 'How much does it cost?',
        body: <>
          <div>
            You can test WTL Studio for free for 7 days. After this period, we will contact you about further subscription.
          </div>
          <div>
            For details regarding the pricing visit our <a href="https://wtlstudio.com/pricing" target="_blank">Pricing page</a>.
          </div>
        </>
      }
    ];    
  }

  return [
    {
      title: 'How does it work?',
      body: <>
        <div>
          <b>You click start and get a website.</b> There, whole magic explained.
        </div>
        <div>
          <br/>
          Moreover! You get access to a powerfull <b>website builder</b>, <b>dozens of plugins</b>, <b>SEO-optimized</b> templates - and more!
        </div>
      </>
    },
    {
      title: 'Can I change parts of the website?',
      body: <>
        <div>
          <b>Yes! In fact, you can change any and all of it.</b> After you create an account, you will get an access to
          WTL Studio website builder which allows you to change nearly every detail of the website. 
        </div>
      </>
    },
    {
      title: 'When will the website be avilable?',
      body: <>
        <div>
          After you create an account, you will receive an activation email from us. Your website becomes available
          within <b>5 minutes</b> after the account is activated.
        </div>
      </>
    },
    {
      title: 'Can I use different website address?',
      body: <>
        <div>
          <b>account</b>.wtlstudio.com is a default address for any WTL Studio website.
        </div>
        <div>
          You can use your own address, like <b>company.com</b>. You will receive the details after activating your account.
        </div>
      </>
    },
    {
      title: 'How much does it cost?',
      body: <>
        <div>
          You can test WTL Studio for free for <b>7 days</b>. After this period, we will contact you about further subscription.
        </div>
        <div>
          For details regarding the pricing visit our <a href="https://wtlstudio.com/pricing" target="_blank">Pricing page</a>.
        </div>
      </>
    }
  ];
}

export const commonFaqSections = [
  {
    title: 'Common Ground.',
    body: <>
      <div>
        The goal of Common is to connect spatial designers with furniture makers. We prepare an environment that is fun, professional and productive - and fill it with real furniture models. Furniture that can be ordered right away when the project is completed.
      </div>
    </>
  },
  {
    title: 'Accessibility.',
    body: <>
      <div>
        As we realised our library of furniture will grow huge over time - we stand prepared for it. The app’s search mechanisms are designed to make browsing furniture models fast and easy. Common determines results & recommendations based not on the popularity, but on how new pieces will influence the  feel and looks of the project. We are dedicated to promote furniture makers of all sizes and styles.
      </div>
    </>
  },
  {
    title: 'Cooperation.',
    body: <>
      <div>
        In certain projects, team work is essential. Team invitations allow two or more people to collaborate on a single project without having to be next to one another. All participants can join the building process, add and remove objects, comment, and engage in discussions. Every project can be easily exported and shared in a variety of forms - an interactive 3d preview, rendered images, or PDF blueprints. This makes it easy for the clients to understand the concept and evaluate the work on every step of the project. 
      </div>
    </>
  },
  {
    title: 'Logistics.',
    body: <>
      <div>
        Common makes it easy to plan out and follow the project’s budget. As the design is built, we sketch out the final price and availability, based on the information we receive from the furniture manufacturers. The final quota - including pricing, taxes, and shipping options - can be shared, printed out, or ordered with a single click.
      </div>
    </>
  },
];


export const whyDungeonsFaqSections = [
  {
    title: 'Your Brand New World',
    body: <>
      <div>
        Join the game on <a href="https://whydungeons.wtlstudio.com" target="_blank">Why Dungeons</a>.
      </div>
    </>
  },
  {
    title: 'Early Access',
    body: <>
      <div>
        This game is in a very early access stage. There are absolutely no guarantees whether it will end up being
        a RPG, flight simulator, or battle royale farming with elements of psychological horror.<br />
        On the other hand - the earlier you join, the more influence you have on the final game.
      </div>
    </>
  },
  {
    title: 'System Requirements',
    body: <>
      <div>
        You play Why Dungeons via browser, so make sure your browser is updated to the latest version.
        Besides that, the only requirement is an active internet connection. Game files are streamed automatically when you play.<br/>
        Please keep in mind that during the early access performance of the game can be a little bit questionable.<br/>
        If you have any touble playing let us know at <a href="mailto:whydungeons@wtlstudio.com">whydungeons@wtlstudio.com</a>.
      </div>
    </>
  },
  {
    title: 'Game as a Service or Subcriptions',
    body: <>
      <div>
        At this point there is no plan to make Why Dungeons a "game-as-a-service" type of game. The only time you pay for the
        game is during the registration, no active subcription is necessary afterwards.<br/>
        Thank you for supporting the project ❤️
      </div>
    </>
  },
  {
    title: 'Refunds',
    body: <>
      <div>
        This is a very early access game. As much as it is heartbreaking for us, it is quite possible that you will not be completely satisfied with it at this point.
        Activation fee is rather a sign of support, not a game sale.<br/>
        If you would like to refund your activation fee let us know at <a href="mailto:whydungeons@wtlstudio.com">whydungeons@wtlstudio.com</a>.
      </div>
    </>
  },
];

export const treasureChestFaqSections = () => [
  {
    title: 'Under Development',
    body: <>
      <div>
        This service is still under development. Please share feedback, if problems occur.
      </div>
    </>
  },
  {
    title: 'Supported Images',
    body: <>
      <div>
        TreasureChest currently supports: <b>png</b>, <b>jpg</b>, <b>bmp</b>, <b>WebP</b>, <b>gif</b>, <b>tiff</b>, <b>HDRI</b>.
      </div>
    </>
  },
  {
    title: 'Supported Models',
    body: <>
      <div>
        TreasureChest currently supports: <b>obj</b>, <b>fbx</b>, <b>glTF</b>, <b>3ds</b>, and a few more.
      </div>
    </>
  },
  {
    title: 'Unsupported Files',
    body: <>
      <div>
        TreasureChest can host any type of file. Files that are not listed as supported do not offer a preview, three.js integration, and codepen integration, but can still be hosted and accessed.
      </div>
    </>
  }
];
